import type { StaticLayerPayload } from "@config";
import { VideoLibrary } from "@library-elements/video";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: VideoLibrary,
};

export const Video = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
